/**
 * 機能ゲート(軸②)で使う課金オプションの安定キー(code)。
 *
 * /auth/me が返す `features.options_enabled` は code の一覧。<Can feature> / hasFeature() は
 * この code で照合する。日本語表示名(name)はマスタでリネームされ得るため照合に使わない。
 * （BE 側 mst_service_options.code / ippon-property-management-backend の OPTION_CODES と一致させる）
 */
export const OPTION_CODES = {
  /** 工事見積査定AI(AI-BPO) */
  ESTIMATE_AI: "estimate_ai",
} as const;

export type OptionCode = (typeof OPTION_CODES)[keyof typeof OPTION_CODES];
